export default (props, vars) =>
  !!props?.['userData']?.['user'] && vars?.['usestate15']?.['state'];
